<template>
  <div class="ticket-msg-container">
    <!-- <page-top></page-top> -->
    <div class="content_wrap">
      <div class="son-page"></div>
      <div class="menu_wrap">
        <div class="ticket_wrap">
          <div :class="[{'act-item':activeIndex==0},'media_font_size_50']" @click="activeIndex=0">在线售票</div>
          <div :class="[{'act-item':activeIndex==1},'media_font_size_50']" @click="activeIndex=1">购票须知</div>
        </div>
        <div class="right_wrap" :style="{'fontSize':'14px'}">
          当前位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>新闻中心</el-breadcrumb-item>
            <el-breadcrumb-item>{{activeIndex==0?'在线售票':'购票须知'}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="online-sell" v-if="activeIndex==0">
        <h2>暂未有相关内容</h2>
      </div>
      <div class="buy_notice" v-if="activeIndex==1">
        <h1 class="media_font_size_70" style="margin:10px 0">购票须知标题</h1>
        <span class="media_font_size_50">购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容</span>
      </div>
    </div>
    <page-bottom></page-bottom>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
import pageBottom from "@/components/pageBottom";
export default {
  components: {
    pageTop,
    pageBottom
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.tab != from.query.tab) {
        this.changeTabs(to.query.tab);
      }
    }
  },
  methods: {
    changeTabs(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style lang="scss">
.ticket-msg-container {
  width: 100vw;
  // height: 2000px;
  min-height: 100vh;
  background: #221f26;
  display: flex;
  flex-direction: column;
  align-items: center;
   justify-content: space-between;
  cursor: default;
  .content_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .son-page {
    width: 1920px;
    height: 300px;
    background-image: url("https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_5_1.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .menu_wrap {
    width: 1200px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;
    .ticket_wrap {
      height: 100px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
      box-sizing: border-box;
      display: flex;
      > div {
        font-size: 30px;
        line-height: 100px;
        text-align: center;
        color: #ccc;
        border-bottom: 2px solid transparent;
        margin-right: 50px;
      }
      .act-item {
        color: #42abff;
        border-bottom: 1px solid #42abff;
      }
    }
    .right_wrap {
      display: flex;
      color: rgba(255, 255, 255, 0.8);
      align-items: center;
    }
  }
  .online-sell {
    color: #fff;
    width: 1200px;
  }
  .buy_notice {
    color: #fff;
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    > span {
      text-indent: 48px;
      font-size: 24px;
      // line-height: 40px;
    }
  }
}
@media screen and (max-width: 1000px) {
  .ticket-msg-container {
    .content_wrap {
      .menu_wrap {
        width: 100vw;
        height: 200px;
        justify-content: center;
        .about_wrap {
          // width: 100%;
          // height: 200px;
        }
        .right_wrap {
          display: none;
        }
      }
    }
  }
}
</style>

<style>
.ticket-msg-container .el-breadcrumb__item .el-breadcrumb__inner {
  color: rgba(255, 255, 255, 0.8) !important;
}
</style>


// WEBPACK FOOTER //
// index.vue?56ec8a7e